var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.387 2.13086C6.5253 2.13086 3.38696 5.26919 3.38696 9.13086V12.5025C3.38696 13.2142 3.08363 14.2992 2.72196 14.9059L1.38029 17.1342C0.551961 18.5109 1.12363 20.0392 2.64029 20.5525C7.66863 22.2325 13.0936 22.2325 18.122 20.5525C19.5336 20.0859 20.152 18.4175 19.382 17.1342L18.0403 14.9059C17.6903 14.2992 17.387 13.2142 17.387 12.5025V9.13086C17.387 5.28086 14.237 2.13086 10.387 2.13086Z",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5452 2.47C11.1343 2.06819 9.63935 2.06819 8.22852 2.47C8.56685 1.60667 9.40685 1 10.3868 1C11.3668 1 12.2068 1.60667 12.5452 2.47Z",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8867 20.9727C13.8867 22.8977 12.3117 24.4727 10.3867 24.4727C9.43005 24.4727 8.54338 24.076 7.91338 23.446C7.2579 22.7895 6.88881 21.9003 6.88672 20.9727",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e6b04e6893e9c7ed2b8b039c144cfcff.svg";
export { ForwardRef as ReactComponent };